/* eslint-disable no-unused-vars */
import _ from 'lodash'

export default (context, inject) => {
  const persistedStore = {

    get lastSelectedContract() {
      return context.store.getters['auth/get']._lastSelectedContract
    },
    set lastSelectedContract(value) {
      context.store.commit('persist/set', {_lastSelectedContract: value})
    }
  }

  inject('persist', persistedStore)
}
